import SessionTypeVisualizeVocabulary from 'frontend/components/school/session-type-visualize-vocabulary';
<template><SessionTypeVisualizeVocabulary @model={{@model}} /></template>
